var _mask, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.551 14.145 12 20.886 8.243 17.02 5.45 14.146l-1.092-1.124c-1.81-1.86-1.81-4.879 0-6.74a4.541 4.541 0 0 1 6.551 0L12 7.405l1.092-1.123a4.541 4.541 0 0 1 6.551 0c1.81 1.861 1.81 4.879 0 6.74l-1.092 1.123Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.551 14.146.717.697.678-.697-.678-.698-.717.698Zm0 0-.717-.698-.678.698.678.697.717-.698ZM12 20.885l-.717.697.717.738.717-.738-.717-.697ZM8.243 17.02l.717-.697-.717.697ZM5.45 14.146l-.717.697.717-.697Zm-1.092-1.124.717-.697-.717.697Zm0-6.74-.717-.697.717.697Zm6.551 0-.717.697.717-.697ZM12 7.405l-.717.697.717.738.717-.738L12 7.405Zm1.092-1.123.717.697-.717-.697Zm6.551 0 .717-.697-.717.697Zm0 6.74-.717-.697.717.697Zm-.375.426-1.434 1.395 1.434-1.395Zm-6.55 8.135 6.55-6.74-1.434-1.394-6.551 6.74 1.434 1.394Zm-5.192-3.865 3.757 3.865 1.434-1.394-3.757-3.866-1.434 1.395Zm-2.794-2.875 2.794 2.875 1.434-1.395-2.794-2.874-1.434 1.394ZM3.64 13.719l1.092 1.124 1.434-1.394-1.092-1.124L3.64 13.72Zm0-8.134c-2.187 2.25-2.187 5.885 0 8.134l1.434-1.394c-1.432-1.473-1.432-3.873 0-5.346L3.64 5.585Zm7.985 0a5.541 5.541 0 0 0-7.985 0L5.074 6.98a3.541 3.541 0 0 1 5.117 0l1.434-1.394Zm1.092 1.123-1.092-1.123-1.434 1.394 1.092 1.123 1.434-1.394Zm0 1.394 1.092-1.123-1.434-1.394-1.092 1.123 1.434 1.394Zm1.092-1.123a3.541 3.541 0 0 1 5.117 0l1.434-1.394a5.541 5.541 0 0 0-7.985 0l1.434 1.394Zm5.117 0c1.432 1.473 1.432 3.873 0 5.346l1.434 1.394c2.187-2.25 2.187-5.885 0-8.134l-1.434 1.394Zm0 5.346-1.092 1.123 1.434 1.394 1.092-1.123-1.434-1.394Z",
    fill: "#222",
    mask: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ec4d1aec.svg";
export { ForwardRef as ReactComponent };